import { combineReducers } from 'redux';
import streaming from './streaming.reducer';

const reducer = combineReducers({
	streaming
});

export default reducer;
